// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___JYbcz","container":"container___3hrg1","size":"size___VReOV","header":"header___1jPOy"};